export const endpoints = {
  channel: (site: string, channelSlug: string) => `/${site}/channels/${channelSlug}`
}
